<template>
  <div>
    <PageHeader :items="items" />
    <validation-observer ref="simpleRules">
      <div class="card">
        <div class="card-body">
          <b-row>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Invoice Type"
                rules="required"
              >
                <label class="input-label form-label"
                  >{{ $t("invoiceType") }}&nbsp;<span style="color: red"
                    >*</span
                  >
                </label>
                <multiselect
                  v-model="form.invoiceType"
                  :key="form.invoiceType"
                  :options="['invoice-correction', 'invoice', 'invoice-storno']"
                  :multiple="false"
                >
                </multiselect>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Due Date"
                rules="required"
              >
                <DatePicker
                  v-model="form.dueDate"
                  :label="$t('dueDate')"
                  :required="true"
                  :isLeftIcon="true"
                  :leftIconName="'dateIcon'"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("receiver") }}&nbsp;<span style="color: red">*</span>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Receiver"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.companyId"
                    :options="customers"
                    label="companyName"
                    trackBy="id"
                    :key="form.companyId"
                    moduleName="customers"
                    :multiple="false"
                    :error="errors[0]"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <div class="form-group">
                <label class="input-label form-label"
                  >{{ $t("sender") }}&nbsp;<span style="color: red">*</span>
                </label>
                <validation-provider
                  #default="{ errors }"
                  name="Sender"
                  rules="required"
                >
                  <MultiSelectInput
                    v-model="form.senderId"
                    :options="customers"
                    label="companyName"
                    trackBy="id"
                    :key="form.senderId"
                    moduleName="customers"
                    :multiple="false"
                    :error="errors[0]"
                    ><template #option="{ props }">
                      <div>
                        <p>
                          {{ props.option.companyNumber }} -
                          {{ props.option.companyName }}
                        </p>
                      </div>
                    </template>
                  </MultiSelectInput>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </div>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="Start Date"
                rules="required"
                ><DatePicker
                  v-model="form.startDate"
                  :label="$t('startDate')"
                  :required="true"
                  :isLeftIcon="true"
                  :leftIconName="'dateIcon'"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <validation-provider
                #default="{ errors }"
                name="End Date"
                rules="required"
                ><DatePicker
                  v-model="form.endDate"
                  :label="$t('endDate')"
                  :required="true"
                  :isLeftIcon="true"
                  :leftIconName="'dateIcon'"
                  :error="errors[0]"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <DatePicker
                v-model="form.invoiceDate"
                :label="$t('invoiceDate')"
                :isLeftIcon="true"
                :leftIconName="'dateIcon'"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <TextInput
                v-model="form.externalOrderNumber"
                type="text"
                :label="$t('externalOrderNumber')"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label" for="cars">{{
                $t("applyReverseCharge")
              }}</label>

              <input
                id="active"
                class="form-check-input-custom ml-2"
                v-model="form.applyReverseCharge"
                type="checkbox"
              />
            </b-col>
            <b-col cols="12" lg="6" md="6" class="mb-1">
              <label class="input-label form-label" for="cars">{{
                $t("customNotesField")
              }}</label>
              <textarea
                class="form-control"
                rows="5"
                v-model="form.customNotesFields"
              />
            </b-col>
          </b-row>
        </div>
      </div>
      <CompanyCard :isCreated="true" :form="form" :user="currentUser" />
      <div class="card">
        <div class="card-header" aria-label="Products Header">
          <h3 class="card-title">
            {{ $t("products") }}
          </h3>
        </div>
        <div class="card-body px-3" aria-label="Products Body">
          <div class="w-100">
            <div
              v-for="(products, index) in form.products"
              :key="index"
              class="mb-2"
            >
              <div class="row align-items-start">
                <!-- <div class="col-md-1">
                  <validation-provider
                    #default="{ errors }"
                    name="POS"
                    rules="required"
                  >
                    <text-input
                      v-model="products.pos"
                      :label="$t('POS')"
                      :required="true"
                      aria-label="POS Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div> -->
                <div class="col-md-2">
                  <validation-provider
                    #default="{ errors }"
                    name="Product Name"
                    rules="required"
                  >
                    <text-input
                      v-model="products.productName"
                      :label="$t('productName')"
                      :required="true"
                      aria-label="Product Name Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <!-- <div class="col-md-2">
                  <text-input
                    v-model="products.caseName"
                    :label="$t('caseName')"
                    aria-label="Case Name Input"
                  />
                </div> -->
                <div class="col-md-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Quantity"
                    rules="required"
                  >
                    <text-input
                      v-model="products.quantity"
                      :label="$t('quantity')"
                      :required="true"
                      type="number"
                      @input="quantityChanged($event, index)"
                      aria-label="Quantity Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-md-1">
                  <validation-provider
                    #default="{ errors }"
                    name="Tax"
                    rules="required"
                  >
                    <text-input
                      v-model="products.tax"
                      :label="$t('tax')"
                      :required="true"
                      type="number"
                      aria-label="Tax Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-md-2">
                  <validation-provider
                    #default="{ errors }"
                    name="Credits"
                    rules="required"
                    class="w-100"
                  >
                    <text-input
                      v-model="products.credits"
                      :label="$t('credits')"
                      :required="true"
                      type="number"
                      @input="priceChanged($event, index)"
                      aria-label="Credits Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-md-2">
                  <label class="input-label form-label"
                    >{{ $t("totalCredits") }}&nbsp;<span style="color: red"
                      >*</span
                    >
                  </label>
                  <div class="mb-1 form-control">
                    <div>
                      {{
                        $formatter(
                          products.totalCredits,
                          $i18n.locale,
                          "EUR",
                          false,
                          2,
                          2
                        )
                      }}
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <validation-provider
                    #default="{ errors }"
                    name="Credit Price"
                    rules="required"
                    class="w-100"
                  >
                    <text-input
                      v-model="products.creditPrice"
                      :label="$t('⌀CreditPrice')"
                      :required="true"
                      type="number"
                      @input="creditPriceChanged($event, index)"
                      aria-label="Credit Price Input"
                      :error="errors[0]"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </div>
                <div class="col-md-2 d-flex align-items-center gap-2">
                  <div class="w-100">
                    <label class="input-label form-label"
                      >{{ $t("productPrice") }}&nbsp;<span style="color: red"
                        >*</span
                      >
                    </label>
                    <div class="mb-1 form-control">
                      <div>
                        {{
                          $formatter(
                            products.nettoTotal,
                            $i18n.locale,
                            "EUR",
                            false,
                            2,
                            2
                          )
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    style="margin-top: 6px"
                    role="button"
                    @click="deleteProducts(index)"
                    aria-label="Delete Products button"
                  >
                    <feather-icon icon="XIcon" size="30" />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div
            v-if="form.products.length > 0"
            class="d-flex align-items-center justify-content-end mt-2"
          >
            <div class="product-total">
              <ul>
                <li>
                  <h3>{{ $t("netto") }}</h3>
                  <p>
                    {{
                      $formatter(totalNetto, $i18n.locale, "EUR", false, 2, 2)
                    }}
                  </p>
                </li>
                <div v-if="!form.applyReverseCharge">
                  <li v-for="(tax, index) in calculateTax" :key="index">
                    <h3>{{$t("tax")}} {{ tax.percent }}%</h3>
                    <p>
                      {{
                        $formatter(tax.amount, $i18n.locale, "EUR", false, 2, 2)
                      }}
                    </p>
                  </li>
                </div>
                <li class="total">
                  <h3>{{ $t("total") }}</h3>
                  <p>
                    {{
                      $formatter(totalAmount, $i18n.locale, "EUR", false, 2, 2)
                    }}
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <b-button variant="primary" @click="addProducts" class="mt-2">
            <feather-icon :icon="'PlusIcon'" size="16" />
            <span>
              {{ $t("addProducts") }}
            </span>
          </b-button>
        </div>
      </div>

      <div class="d-flex align-items-center justify-content-end">
        <b-button
          :disabled="isLoading || isFormInvalid"
          variant="primary"
          @click="createInvoice"
          class="d-flex align-items-center gap-1"
          v-if="$can(`${$route.meta.permission}.create`)"
        >
          <feather-icon icon="PlusIcon" size="12" />
          <span>{{ $t("createInvoice") }}</span>
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import TextInput from "@/components/TextInput.vue";
import PageHeader from "@/components/PageHeader.vue";
import Multiselect from "vue-multiselect";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { mapGetters } from "vuex";
import { required, email } from "@validations";
import MultiSelectInput from "@/components/MultiSelectInput.vue";
import DatePicker from "@/components/DatePicker.vue";
import ElementsIcon from "@/components/elements/Icon.vue";
import CompanyCard from "./components/CompanyCard.vue";
import formDirtyMixin from "@/mixins/formDirtyMixin";
export default {
  components: {
    TextInput,
    PageHeader,
    ValidationProvider,
    ValidationObserver,
    Multiselect,
    MultiSelectInput,
    DatePicker,
    ElementsIcon,
    CompanyCard,
  },
  mixins: [formDirtyMixin],
  watch: {
    form: {
      handler(newVal) {
        this.isFormDirty = JSON.stringify(newVal) !== this.originalForm;
      },
      deep: true,
    },
  },
  computed: {
    ...mapGetters("auth", ["user"]),
    ...mapGetters("customers", ["customers"]),
    totalNetto() {
      return this.form.products.reduce((sum, product) => {
        return sum + parseFloat(product.nettoTotal || 0);
      }, 0);
    },
    totalAmount() {
      // Sum all the taxes from calculateTax and add totalNetto
      const totalTaxes = this.calculateTax.reduce((sum, tax) => {
        return sum + parseFloat(tax.amount);
      }, 0);

      return parseFloat(this.totalNetto + totalTaxes).toFixed(2);
    },
    calculateTax() {
      if (this.form.applyReverseCharge) {
        // If reverse charge is applied, all amounts should be zero
        return Object.keys(
          this.form.products.reduce((result, product) => {
            result[product.tax] = 0;
            return result;
          }, {})
        ).map((tax) => ({
          percent: tax,
          amount: "0.00",
        }));
      }

      const groupedProducts = this.form.products.reduce((result, product) => {
        const tax = product.tax;
        if (!result[tax]) {
          result[tax] = [];
        }
        result[tax].push(product);
        return result;
      }, {});

      const result = Object.entries(groupedProducts).map(([tax, products]) => {
        const totalTaxAmount = products.reduce((sum, product) => {
          const nettoTotal = parseFloat(product.nettoTotal) || 0;
          const taxAmount = (nettoTotal * parseFloat(tax)) / 100;
          return sum + taxAmount;
        }, 0);

        return {
          percent: tax,
          amount: parseFloat(totalTaxAmount).toFixed(2),
        };
      });

      return result;
    },
    items() {
      return [
        {
          text: "Dental Twin",
          to: "/home",
        },
        {
          text: this.$t("invoices"),
          to: "/invoices",
        },
        {
          text: this.$t("create"),
          active: true,
        },
      ];
    },
    isFormInvalid() {
      return (
        !this.form.companyId ||
        !this.form.senderId ||
        !this.form.startDate ||
        !this.form.endDate ||
        !this.form.dueDate ||
        !this.form.invoiceType ||
        !this.form.products.length > 0 ||
        !this.form.products.every(
          (product) =>
            product.productName &&
            product.quantity &&
            product.tax &&
            product.credits &&
            product.creditPrice &&
            product.nettoTotal
        )
      );
    },
  },
  data() {
    return {
      originalForm: null,
      isLoading: false,
      currentUser: {},
      form: {
        invoiceType: "",
        companyId: "",
        senderId: "",
        dueDate: this.formatDate(new Date()),
        startDate: this.formatDate(new Date()),
        endDate: this.formatDate(
          new Date(new Date().getFullYear(), new Date().getMonth() + 1, 0)
        ),
        invoiceDate: this.formatDate(new Date()),
        externalOrderNumber: "",
        applyReverseCharge: false,
        products: [],
        status: "draft",
        customNotesFields: "",
      },
    };
  },
  async created() {
    try {
      this.$store.commit("showLoader", true);
      await this.$store.dispatch("customers/list");
      this.currentUser = this.user;

      this.originalForm = JSON.stringify(this.form);
    } catch (e) {
      console.error("api error ___", e);
    } finally {
      this.$store.commit("showLoader", false);
    }
  },

  methods: {
    addProducts() {
      this.form.products.push({
        // pos: this.form.products.length + 1,
        productName: "",
        // caseName: "",
        credits: "",
        quantity: "",
        tax: "19",
        totalCredits: "",
        creditPrice: 1,
        nettoTotal: "0.00",
      });
    },
    quantityChanged(event, index) {
      this.form.products[index].nettoTotal =
        event *
        this.form.products[index].credits *
        this.form.products[index].creditPrice;
      this.form.products[index].totalCredits =
        event * this.form.products[index].credits;
    },
    creditPriceChanged(event, index) {
      this.form.products[index].nettoTotal =
        event *
        this.form.products[index].credits *
        this.form.products[index].quantity;
    },
    formatDate(date) {
      let year = date.getFullYear();
      let month = ("0" + (date.getMonth() + 1)).slice(-2); // Add leading zero if needed
      let day = ("0" + date.getDate()).slice(-2); // Add leading zero if needed
      return `${year}-${month}-${day}`;
    },
    priceChanged(event, index) {
      this.form.products[index].nettoTotal =
        event *
        this.form.products[index].creditPrice *
        this.form.products[index].quantity;
      this.form.products[index].totalCredits =
        event * this.form.products[index].quantity;
    },
    async deleteProducts(index) {
      const confirmed = await this.showConfirmationDialog({
        title: this.$t("doYouWantToDeleteThisRecord"),
        subText: this.$t("yesDeleteIt"),
      });

      if (confirmed) {
        this.form.products.splice(index, 1);
      }
    },
    async createInvoice() {
      this.$refs.simpleRules.validate().then(async (success) => {
        if (success) {
          const totalTaxes = this.calculateTax.reduce((sum, tax) => {
            return sum + parseFloat(tax.amount);
          }, 0);
          this.isLoading = true;
          await this.$store
            .dispatch("invoices/create", {
              ...this.form,
              companyId: this.form.companyId?.id ?? "",
              senderId: this.form.senderId?.id ?? "",
              totalAmount: this.totalAmount,
              taxAmount: totalTaxes,
              netto: this.totalNetto,
            })
            .finally(() => {
              this.isLoading = false;
            });
          this.isFormDirty = false;
          this.originalForm = JSON.stringify(this.form);
          this.$router.push("/invoices");
        }
      });
    },
  },
};
</script>

<style scoped>
#nprogress {
  position: relative;
  z-index: 9999999;
}

.white-color {
  color: white !important;
}

.vgt-responsive {
  overflow-x: visible !important;
}
</style>
